webpackJsonp([190176442836051],{

/***/ 637:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-pages----CreditsPage-module---wrapper---1IiWz"};

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.creditsQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageWrapper = __webpack_require__(56);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _TextContainer = __webpack_require__(104);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _Inner = __webpack_require__(48);
	
	var _Inner2 = _interopRequireDefault(_Inner);
	
	var _CreditsPageModule = __webpack_require__(637);
	
	var _CreditsPageModule2 = _interopRequireDefault(_CreditsPageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemotePage = function RemotePage(props) {
	  function createContent() {
	    return { __html: props.data.allFile.edges[0].node.childMarkdownRemark.html };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _CreditsPageModule2.default.wrapper },
	    _react2.default.createElement(
	      _PageWrapper2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Website Credits - Dominion Systems, LLC', meta: [] }),
	      _react2.default.createElement(
	        _Inner2.default,
	        null,
	        _react2.default.createElement(
	          _TextContainer2.default,
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            props.data.allFile.edges[0].node.childMarkdownRemark.frontmatter.title
	          ),
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: createContent() }),
	          ' '
	        )
	      )
	    )
	  );
	};
	
	exports.default = RemotePage;
	var creditsQuery = exports.creditsQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-credits-js-9ef9e53c840017acd9ec.js